// extracted by mini-css-extract-plugin
export var header = "style-module--header--zPrCR";